module.exports = __webpack_public_path__ + "img/yellow.84a4724a.png";